/**
 * 自定义
 * */
/* eslint-disable */
export default {
    namespaced: true,
    state: {
        // API
        // BaseUrl: 'http://localhost:50002',
        // BaseUrl1: 'http://localhost:50002/Gemini',
        // BaseUrl: 'https://api.yyq_cloudmall.gemini-galaxy.com/',
        // BaseUrl1: 'https://api.yyq_cloudmall.gemini-galaxy.com//Gemini',
        // BaseUrl: 'https://api.yyq_cloudmall.gemini-galaxy.com/',
        // BaseUrl1: 'https://api.yyq_cloudmall.gemini-galaxy.com//Gemini',
    },
    actions: {},
    mutations: {},
};
